import { useHistory } from 'react-router';
import { TrainingState, useTrainingStore } from './state';
import { useTrainingUrl } from './useTrainingUrl';

const selector = (state: TrainingState) => state.prev;

export function usePrevSequence() {
  const url = useTrainingUrl();
  const history = useHistory();
  const prev = useTrainingStore(selector);

  return async () => {
    const id = await prev();
    history.push(`${url}/${id}`);
  };
}
